import { Component, EventEmitter, Input, Output } from '@angular/core';
import { type AbstractControl } from '@angular/forms';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { AttachmentStatus, type Attachment } from '../../interfaces';
import { LoaderTheme } from '../../loader';
import { NotificationTheme } from '../../notifications';

@Component({
  selector: 'fcom-attachment-list',
  templateUrl: './attachment-list.component.html',
  standalone: false,
})
export class AttachmentListComponent {
  readonly AttachmentStatus = AttachmentStatus;
  readonly LoaderTheme = LoaderTheme;
  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input({ required: true }) attachments: Attachment[];
  @Input() ctrlField: AbstractControl<Attachment[]>;
  @Output() fileDeleted: EventEmitter<Attachment> = new EventEmitter<Attachment>();

  deleteAttachment(attachment: Attachment): void {
    this.fileDeleted.emit(attachment);
  }
}
